var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgStop = function SvgStop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 369.949 369.949",
    style: {
      enableBackground: "new 0 0 369.949 369.949"
    },
    xmlSpace: "preserve"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184.975 0C82.824 0 .003 82.824.003 184.978c0 102.147 82.821 184.972 184.972 184.972 102.153 0 184.972-82.824 184.972-184.972C369.946 82.824 287.128 0 184.975 0zm0 353.515c-92.942 0-168.536-75.613-168.536-168.537 0-92.93 75.594-168.537 168.536-168.537 92.931 0 168.53 75.606 168.53 168.537 0 92.923-75.6 168.537-168.53 168.537z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M190.775 172.758H328.22c-6.233-73.619-68.053-131.649-143.245-131.649-79.326 0-143.866 64.54-143.866 143.869s64.54 143.881 143.866 143.881c74.447 0 135.864-56.865 143.143-129.439H190.775L201.343 210c5.206 5.207 5.206 13.644 0 18.844-5.212 5.212-13.646 5.212-18.852 0l-33.314-33.32c-.015-.007-.015-.019-.027-.019l-9.413-9.415 9.413-9.413c.012 0 .012-.012.027-.018l31.093-31.102a13.302 13.302 0 0 1 9.427-3.906c3.408 0 6.818 1.3 9.425 3.906 5.212 5.207 5.212 13.644 0 18.847l-8.347 8.354z"
  })));
};

export default SvgStop;